/** DTOs keys for "helpdesk" module */
export enum HelpdeskDtoKeyEnum {
  /** Helpdesk task find one API query parameters (additional options) */
  HELPDESK_TASK_FIND_ONE_QUERY_DTO = 'helpdesk/helpdesk-task-find-one-query.dto',
  /** Helpdesk task merge API URL parameters */
  HELPDESK_TASK_MERGE_INTO_PARAMS_DTO = 'helpdesk/helpdesk-task-merge-into-params.dto',
  /** Helpdesk tasks plot API query parameters */
  HELPDESK_TASK_PLOT_QUERY_DTO = 'helpdesk/helpdesk-task-plot-query.dto',
  /** Helpdesk tasks plot API own settings */
  HELPDESK_TASK_PLOT_SETTINGS_DTO = 'helpdesk/helpdesk-task-plot-settings.dto',
  /** Helpdesk task selection settings */
  HELPDESK_TASK_SELECT_DTO = 'helpdesk/helpdesk-task-select.dto',
  /** Helpdesk task sorting settings */
  HELPDESK_TASK_SORT_DTO = 'helpdesk/helpdesk-task-sort.dto',
  /** Helpdesk tasks subtotal API response body item */
  HELPDESK_TASK_SUBTOTAL_ITEM_DTO = 'helpdesk/helpdesk-task-subtotal-item.dto',
  /** Helpdesk tasks subtotal API query parameters */
  HELPDESK_TASK_SUBTOTAL_QUERY_DTO = 'helpdesk/helpdesk-task-subtotal-query.dto',
  /** Helpdesk tasks subtotal API own settings */
  HELPDESK_TASK_SUBTOTAL_SETTINGS_DTO = 'helpdesk/helpdesk-task-subtotal-settings.dto',
  /** Helpdesk tasks subtotal API response body */
  HELPDESK_TASK_SUBTOTAL_DTO = 'helpdesk/helpdesk-task-subtotal.dto',
  /** Helpdesk tasks total data */
  HELPDESK_TASK_TOTAL_DATA_DTO = 'helpdesk/helpdesk-task-total-data.dto',
  /** Helpdesk tasks total API query parameters */
  HELPDESK_TASK_TOTAL_QUERY_DTO = 'helpdesk/helpdesk-task-total-query.dto',
  /** Helpdesk tasks total API response body */
  HELPDESK_TASK_TOTAL_DTO = 'helpdesk/helpdesk-task-total.dto',
  /** Helpdesk task for personal account create API request body */
  HELPDESK_TASK_PERSONAL_ACCOUNT_CREATE_DTO = 'helpdesk/helpdesk-task-personal-account-create.dto',
  /** Helpdesk task list for personal account filters */
  HELPDESK_TASK_PERSONAL_ACCOUNT_FILTERS_DTO = 'helpdesk/helpdesk-task-personal-account-filters.dto',
  /** Helpdesk task for personal account create and update APIs request body */
  HELPDESK_TASK_PERSONAL_ACCOUNT_FORM_DTO = 'helpdesk/helpdesk-task-personal-account-form.dto',
  /** Helpdesk task for personal account partial update API request body */
  HELPDESK_TASK_PERSONAL_ACCOUNT_PARTIAL_FORM_DTO = 'helpdesk/helpdesk-task-personal-account-partial-form.dto',
  /** Personal-account HelpDesk task card descriptor API query parameters */
  HELPDESK_TASK_PERSONAL_ACCOUNT_CARD_DESCRIPTOR_QUERY_DTO = 'helpdesk/helpdesk-task-personal-account-card-descriptor-query.dto',
  /** Helpdesk task list for personal account API query parameters */
  HELPDESK_TASK_PERSONAL_ACCOUNT_QUERY_DTO = 'helpdesk/helpdesk-task-personal-account-query.dto',
  /** HelpDesk task report item response body */
  HELPDESK_TASK_REPORT_ITEM_DTO = 'helpdesk/helpdesk-task-report-item.dto',
  /** HelpDesk task report query parameters */
  HELPDESK_TASK_REPORT_QUERY_DTO = 'helpdesk/helpdesk-task-report-query.dto',
  /** HelpDesk task report summary per responsible response body */
  HELPDESK_TASK_REPORT_SUMMARY_DTO = 'helpdesk/helpdesk-task-report-summary.dto',
  /** Helpdesk task report summary by task type response body */
  HELPDESK_TASK_REPORT_SUMS_BY_TASK_TYPE_DTO = 'helpdesk/helpdesk-task-report-sums-by-task-type.dto',
  /** Helpdesk task report summary by unit response body */
  HELPDESK_TASK_REPORT_SUMS_BY_UNIT_DTO = 'helpdesk/helpdesk-task-report-sums-by-unit.dto',
  /** Helpdesk task report summary response body */
  HELPDESK_TASK_REPORT_SUMS_DTO = 'helpdesk/helpdesk-task-report-sums.dto',
  /** HelpDesk task type response body */
  HELPDESK_TASK_TYPE_FIND_DTO = 'helpdesk/helpdesk-task-type-find.dto',
  /** HelpDesk task type create/update request body */
  HELPDESK_TASK_TYPE_FORM_DTO = 'helpdesk/helpdesk-task-type-form.dto',
  /** HelpDesk task types list API query parameters */
  HELPDESK_TASK_TYPE_LIST_QUERY_DTO = 'helpdesk/helpdesk-task-type-list-query.dto',
  /** HelpDesk task type registry column selection */
  HELPDESK_TASK_TYPE_SELECT_DTO = 'helpdesk/helpdesk-task-type-select.dto',
  /** HelpDesk task type sorting settings */
  HELPDESK_TASK_TYPE_SORT_DTO = 'helpdesk/helpdesk-task-type-sort.dto',
  /** HelpDesk task type registry API query parameters */
  HELPDESK_TASK_TYPE_REGISTRY_QUERY_DTO = 'helpdesk/helpdesk-task-type-registry-query.dto',
  /** HelpDesk task type export to file API query parameters */
  HELPDESK_TASK_TYPE_EXPORT_QUERY_DTO = 'helpdesk/helpdesk-task-type-export-query.dto',
  /** HelpDesk task type registry items page */
  HELPDESK_TASK_TYPE_PAGE_DTO = 'helpdesk/helpdesk-task-type-page.dto',
  /** HelpDesk task partial update request body */
  HELPDESK_TASK_TYPE_PARTIAL_UPDATE_DTO = 'helpdesk/helpdesk-task-type-partial-update.dto',
  /** HelpDesk task required fields get and set APIs requests body */
  HELPDESK_TASK_REQUIRED_FIELDS_DTO = 'helpdesk/helpdesk-task-required-fields.dto',
  /** Reschedule HelpDesk task (change deadline) API request body */
  HELPDESK_TASK_RESCHEDULE_DTO = 'helpdesk/helpdesk-task-reschedule.dto',
  /** Helpdesk notificaction settings common body */
  HELPDESK_NOTIFICATION_SETTINGS_DTO = 'helpdesk/helpdesk-notification-settings.dto',
  /** Helpdesk task template response body */
  HELPDESK_TASK_TEMPLATE_FIND_DTO = 'helpdesk/helpdesk-task-template-find.dto',
  /** Helpdesk task template registry filter parameters */
  HELPDESK_TASK_TEMPLATE_REGISTRY_FILTERS_DTO = 'helpdesk/helpdesk-task-template-registry-filters.dto',
  /** Helpdesk task template registry selectable columns */
  HELPDESK_TASK_TEMPLATE_REGISTRY_SELECTABLE_ITEM_DTO = 'helpdesk/helpdesk-task-template-registry-selectable-item.dto',
  /** Helpdesk task template registry column selection */
  HELPDESK_TASK_TEMPLATE_SELECT_DTO = 'helpdesk/helpdesk-task-template-select.dto',
  /** Helpdesk task template sorting settings */
  HELPDESK_TASK_TEMPLATE_SORT_DTO = 'helpdesk/helpdesk-task-template-sort.dto',
  /** Helpdesk task template registry API query parameters */
  HELPDESK_TASK_TEMPLATE_REGISTRY_QUERY_DTO = 'helpdesk/helpdesk-task-template-registry-query.dto',
  /** Helpdesk task template export to file API query parameters */
  HELPDESK_TASK_TEMPLATE_EXPORT_QUERY_DTO = 'helpdesk/helpdesk-task-template-export-query.dto',
  /** Helpdesk task templates registry items page */
  HELPDESK_TASK_TEMPLATE_PAGE_DTO = 'helpdesk/helpdesk-task-template-page.dto',
  /** Helpdesk task template find one API additional query parameters */
  HELPDESK_TASK_TEMPLATE_PERSONAL_ACCOUNT_FIND_ONE_QUERY_DTO = 'helpdesk/helpdesk-task-template-personal-account-find-one-query.dto',
  /** Helpdesk task template response body for personal account mode */
  HELPDESK_TASK_TEMPLATE_PERSONAL_ACCOUNT_FIND_DTO = 'helpdesk/helpdesk-task-template-personal-account-find.dto',
  /** Helpdesk task template create/update request body for personal account mode */
  HELPDESK_TASK_TEMPLATE_PERSONAL_ACCOUNT_FORM_DTO = 'helpdesk/helpdesk-task-template-personal-account-form.dto',
  /** Helpdesk task templates list with pagination APIs response body for personal account mode */
  HELPDESK_TASK_TEMPLATE_PERSONAL_ACCOUNT_PAGE_DTO = 'helpdesk/helpdesk-task-template-personal-account-page.dto',
  /** Helpdesk task template partial update request body for personal account mode */
  HELPDESK_TASK_TEMPLATE_PERSONAL_ACCOUNT_PARTIAL_FORM_DTO = 'helpdesk/helpdesk-task-template-personal-account-partial-form.dto',
  /** Helpdesk task template list API query parameters for personal account mode */
  HELPDESK_TASK_TEMPLATE_PERSONAL_ACCOUNT_QUERY_DTO = 'helpdesk/helpdesk-task-template-personal-account-query.dto',
  /** Helpdesk task create/update request body */
  HELPDESK_TASK_FORM_DTO = 'helpdesk/helpdesk-task-form.dto',
  /** Helpdesk task API response body */
  HELPDESK_TASK_FIND_DTO = 'helpdesk/helpdesk-task-find.dto',
  /** Helpdesk task list with pagination APIs response body */
  HELPDESK_TASK_PAGE_DTO = 'helpdesk/helpdesk-task-page.dto',
  /** Helpdesk task list with pagination APIs response body (personal account registry v2) */
  HELPDESK_TASK_PERSONAL_ACCOUNT_PAGE_DTO = 'helpdesk/helpdesk-task-personal-account-page.dto',
  /** HelpDesk task query parameters */
  HELPDESK_TASK_QUERY_DTO = 'helpdesk/helpdesk-task-query.dto',
  /** HelpDesk task export to file API query parameters */
  HELPDESK_TASK_EXPORT_QUERY_DTO = 'helpdesk/helpdesk-task-export-query.dto',
  /** HelpDesk task list filters parameters */
  HELPDESK_TASK_FILTERS_DTO = 'helpdesk/helpdesk-task-filters.dto',
  /** Helpdesk task status API response body */
  HELPDESK_TASK_STATUS_FIND_DTO = 'helpdesk/helpdesk-task-status-find.dto',
  /** Helpdesk task partial update request body */
  HELPDESK_TASK_PARIAL_UPDATE_FORM_DTO = 'helpdesk/helpdesk-task-partial-update-form.dto',
  /** Helpdesk task fact time API response body */
  HELPDESK_TASK_FACT_TIME_FIND_DTO = 'helpdesk/helpdesk-task-fact-time-find.dto',
  /** Helpdesk task change status API request body */
  HELPDESK_TASK_CHANGE_STATUS_FORM_DTO = 'helpdesk/helpdesk-task-change-status-form.dto',
  /** Create many HD tasks from template for counterparties API request body */
  HELPDESK_CREATE_MANY_FROM_TEMPLATE_FOR_CONTRAGENTS_FORM_DTO = 'helpdesk/helpdesk-create-many-from-template-for-contragents-form.dto',
  /** Helpdesk task delegate API request body */
  HELPDESK_TASK_DELEGATE_FORM_DTO = 'helpdesk/helpdesk-task-delegate-form.dto',
  /** Helpdesk task change client API request body */
  HELPDESK_TASK_CHANGE_CLIENT_FORM_DTO = 'helpdesk/helpdesk-task-change-client-form.dto',
  /** Helpdesk task bulk contacts assign API request body */
  HELPDESK_TASK_BULK_CONTACTS_ASSIGN_FORM_DTO = 'helpdesk/helpdesk-task-bulk-contacts-assign-form.dto',
  /** Helpdesk task many bulk contacts assign API request body */
  HELPDESK_TASK_BULK_CONTACTS_ASSIGN_MANY_FORM_DTO = 'helpdesk/helpdesk-task-bulk-contacts-assign-many-form.dto',
  /** Helpdesk task count API response body */
  HELPDESK_TASK_COUNT_FIND_DTO = 'helpdesk/helpdesk-task-count-find.dto',
  /** HelpDesk task search query parameters */
  HELPDESK_TASK_SEARCH_QUERY_DTO = 'helpdesk/helpdesk-task-search-query.dto',
  /** Helpdesk task email API response body */
  HELPDESK_TASK_EMAIL_FIND_DTO = 'helpdesk/helpdesk-task-email-find.dto',
  /** Helpdesk task email API request body */
  HELPDESK_TASK_EMAIL_FORM_DTO = 'helpdesk/helpdesk-task-email-form.dto',
  /** Helpdesk task auditor API request body */
  HELPDESK_TASK_AUDITOR_FORM_DTO = 'helpdesk/helpdesk-task-auditor-form.dto',
  /** Helpdesk task template API response body */
  HELPDESK_TASK_TEMPLATE_DTO = 'helpdesk/helpdesk-task-template.dto',
}
